import styles from "./BalanceHistory.module.scss";
import clockIcon from "../../../../../assets/images/packages/Clock.svg";
import { BalanceHistoryDataType } from "../../../../../interface/site.interface";
import { formatDate } from "../../../../../extentions/date";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
interface BalanceHistoryProps {
  balanceHistory: BalanceHistoryDataType[] | undefined;
  myBalance: {
    balance: string;
    get_page: {
      add_balance: string;
      balance_log: string;
      balance_text: string;
      add_balance_save: string;
      balance: string;
      amount: string;
    };
  };
}
export default function BalanceHistory({
  balanceHistory,
  myBalance,
}: BalanceHistoryProps) {
  const { data } = useSelector((state: RootState) => state.translationData);
  const getTypeLabel = (type: string) => {
    switch (type.toLowerCase()) {
      case "cart":
        return data?.by_card;
      case "balance":
        return data?.from_balance;
      case "courier":
        return data?.by_courier;
      case "cash":
        return data?.cash;
      case "service_debt":
        return data?.payment_log_service_debt || "Əlavə xidmətlər borcu";
      default:
        return type.charAt(0).toUpperCase() + type.slice(1);
    }
  };

  return (
    <div className={styles.balance_history_container}>
      <p className={styles.balance_history_title}>
        {myBalance.get_page.balance_log}
      </p>

      {/* <div className={styles.history_items_container}>
        <div className={styles.history_item}>
          <div className={styles.history_clock_icon_container}>
            <img src={clockIcon} alt="clock" />
          </div>

          <div className={styles.history_item_details}>
            <div className={styles.history_item_details_date}>
              <p className={styles.history_item_date_title}>Son ödəniş</p>

              <p className={styles.history_item_date_text}>08/09/2024 </p>
            </div>

            <p className={styles.history_item_amount}>20.00 azn</p>
          </div>
        </div>
        <div className={styles.history_item}>
          <div className={styles.history_clock_icon_container}>
            <img src={clockIcon} alt="clock" />
          </div>

          <div className={styles.history_item_details}>
            <div className={styles.history_item_details_date}>
              <p className={styles.history_item_date_title}>Son ödəniş</p>

              <p className={styles.history_item_date_text}>08/09/2024 </p>
            </div>

            <p className={styles.history_item_amount}>20.00 azn</p>
          </div>
        </div>
        <div className={styles.history_item}>
          <div className={styles.history_clock_icon_container}>
            <img src={clockIcon} alt="clock" />
          </div>

          <div className={styles.history_item_details}>
            <div className={styles.history_item_details_date}>
              <p className={styles.history_item_date_title}>Son ödəniş</p>

              <p className={styles.history_item_date_text}>08/09/2024 </p>
            </div>

            <p className={styles.history_item_amount}>20.00 azn</p>
          </div>
        </div>
      </div> */}

      {balanceHistory?.length !== 0 ? (
        balanceHistory?.map((item, index) => {
          return (
            <div className={styles.history_items_container}>
              <div className={styles.history_item}>
                <div className={styles.history_clock_icon_container}>
                  <img src={clockIcon} alt="clock" />
                </div>

                <div className={styles.history_item_details}>
                  <div className={styles.history_item_details_date}>
                    <p className={styles.history_item_date_title}>
                      {getTypeLabel(item.type)}
                    </p>

                    <p className={styles.history_item_date_text}>
                      {formatDate(item.created_at)}{" "}
                    </p>
                  </div>

                  <p
                    style={{
                      color: item.status === "in" ? "#498060" : "red",
                    }}
                    className={styles.history_item_amount}
                  >
                    {item?.status === "in" ? "+" : "-"} {item.amount} $
                  </p>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className={styles.no_history}>
          <p>Tarixçənizdə heç bir ödəniş yoxdur</p>
        </div>
      )}
    </div>
  );
}
